const Venue = () => {
    return (
        <>
            <div className="venue flex flex-col items-center justify-around lg:flex-row my-8">
                <div className="venue-content text-center">
                    <h1 className="lgreen">Venue</h1>
                    <p>
                        IITB Research Park Foundation,<br />
                        Research Park Building,<br />
                        IIT Bombay, Mumbai - 400076
                    </p>
                </div>

                <div className="map h-4/5">
                    <iframe
                        src="https://www.google.com/maps?q=IITB+Research+Park+Foundation,+Research+Park+Building,+IIT+Bombay,+Mumbai+-+400076&output=embed"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="IITB Research Park Foundation"
                    />
                </div>
            </div>

            {/*
            <div className="reach-NSE">
                <div className="aboutt">
                    <h1 className="dblue">How to Reach Venue</h1>

                    <h4>Nearest Airport - Mumbai (6.7 kms)</h4>
                    <h4>Nearest Railway Station (Western line) - Bandra (2.9 km)</h4>
                    <h4>Nearest Railways Station (Central line) - Kurla (3.3 km)</h4>

                </div>
            </div>
            */}
        </>
    );
};

export default Venue;

// const Venue = () => {
//     return (
//         <>
//             <div className="venue flex flex-col items-center justify-around lg:flex-row my-8">
//                 <div className="venue-content text-center">
//                     <h1 className="lgreen">Venue</h1>
//                     <p>Victor Menezes Convention,<br />Centre (VMCC),<br />
//                         IIT Bombay ,Powai,<br />
//                         Mumbai – 400 051<br />
//                         Maharashtra, India
//                     </p>
//                 </div>
//                 <div className="map h-4/5">
//                     <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.4205383314343!2d72.9151061!3d19.1330605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7f189efc039%3A0x68fdcea4c5c5894e!2sIndian%20Institute%20of%20Technology%20Bombay!5e0!3m2!1sen!2sin!4v1760723820017!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
//                 </div>

//             </div>
//             {/* <div className="reach-NSE">
//                 <div className="aboutt">
//                     <h1 className="dblue">How to Reach Venue</h1>

//                     <h4>Nearest Airport - Mumbai (6.7 kms)</h4>
//                     <h4>Nearest Railway Station (Western line) - Bandra (2.9 km) </h4>
//                     <h4>Nearest Railways Station (Central line) - Kurla (3.3 km)</h4>

//                 </div>
//             </div> */}


//         </>
//     );
// }

// export default Venue;
